<div *ngIf="show" style="top: 40px; position: absolute; right: 25px">
  <i
    class="fal fa-spinner fa-spin fa-fw"
    style="color: #212121de; font-size: 21px"
  ></i>
</div>
